export const SORT_FIELD_MAP: Record<string, string> = {
  classificationCreateDate: "classificationCreateDate",
  description: "presentationName",
  createAt: "createdAt",
};

export const resolveSortByField = (
  field?: string,
  fallback: string = "classificationCreateDate",
): string => {
  if (!field) return fallback;
  return SORT_FIELD_MAP[field] || field;
};
